import React from 'react';

import { PERMISSIONS } from 'contexts/PermissionsContext';
import ContextualMenu from '../ContextualMenu';

import { HighlightBlock, HighlightBlockWrapper } from './styles';

export const DetailsChartHighlightBlock = props => {
	const {
		left,
		width,
		height,
		grouppedItemIndex,
		tailSpendItemIndex,
		categories,
		isTailSpend,
		onViewTransactionsClick,
		onChangeStatusClick,
		onMoveToBinClick,
		onSetTargetClick,
		onTopVendorsClick,
		onItemClick,
		permissions,
		selectedLeafIndex,
		hideContextualMenu,
		hideIndex,
		className,
	} = props;

	const hasWritePermissions =
		permissions && permissions.includes(PERMISSIONS.TransactionsWrite);
	const hasTrackPermissions =
		permissions && permissions.includes(PERMISSIONS.TrackingWrite);

	const [menuOpenIndex, setMenuOpenIndex] = React.useState(null);
	const itemWidth = width / categories.length;

	const shouldHideMenuItemAt = index => {
		return Array.isArray(grouppedItemIndex)
			? grouppedItemIndex.includes(index)
			: index === grouppedItemIndex;
	};

	return (
		<HighlightBlockWrapper
			left={left}
			width={width}
			height={height}
			isActive={!menuOpenIndex}
			className={className}
		>
			{categories &&
				categories.map(
					(_0, index) =>
						hideIndex !== index ? (
							<HighlightBlock
								key={index}
								width={itemWidth}
								left={index * itemWidth}
								onClick={() => onItemClick(index)}
								isActive={
									menuOpenIndex === index || selectedLeafIndex === index
								}
							>
								{!hideContextualMenu &&
									!shouldHideMenuItemAt(index) && (
										<ContextualMenu
											onViewTransactions={() => onViewTransactionsClick(index)}
											onChangeStatus={
												!isTailSpend &&
												tailSpendItemIndex !== index &&
												(() => onChangeStatusClick(index))
											}
											onShowTopVendors={() => onTopVendorsClick(index)}
											setTarget={
												!isTailSpend &&
												tailSpendItemIndex !== index &&
												onSetTargetClick &&
												(() => onSetTargetClick(index))
											}
											moveToBin={
												!isTailSpend &&
												tailSpendItemIndex !== index &&
												(() => onMoveToBinClick(index))
											}
											hasWritePermissions={hasWritePermissions}
											hasTrackPermissions={hasTrackPermissions}
											toggleMenu={isOpen =>
												setMenuOpenIndex(isOpen ? index : null)
											}
											isOpen={menuOpenIndex === index}
										/>
									)}
							</HighlightBlock>
						) : null
				)}
		</HighlightBlockWrapper>
	);
};

export default DetailsChartHighlightBlock;
